import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'serviceLabel'})

export class ServiceLabelPipe implements PipeTransform {

  transform(value: number): string {
    if(value > 1){
        return `${value} persone`
    }else if(value = 1){
        return `${value} persona`
    }
      return ''
  }
}